export const mainColor = "#63BEFF";
export const mainColorHover = "#58A6DE";

//= ===== COLOR VARIABLES ======//
export const blue = "#0076ff";
export const red = "#a51a1a";
export const black = "#24292e";
export const slateGrey = "#97A2B9";
export const fadedBlue = "#E6EBF9";
export const lightGrey = "#F9F9F9";
export const white = "#FFFFFF";
export const dark = "#444";
export const purple = "#0e1a35";
// export const rgb_red = ${rgba(255,255,255,.6)};
